// import Vue from 'vue';

import store from '../store/store';
import axios from 'axios';
var qs = require('qs');

export default {
  login(data) {
    let newData = Object.assign({}, data.form);
    data.form.password = '';
    newData.grant_type = "password";
    return axios.post(newData.url+`/oauth2/token`, qs.stringify(newData))
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  authenticate() {
    const url = store.getters['auth/url'];
    return axios.get(url+`/api/v1/users/current`)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
};


// WEBPACK FOOTER //
// ./src/services/Auth.js